<template>
  <div id="DisposableClockIn_main">
    <el-dialog
      title="一次性打卡申請"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="680px"
      @close="init"
    >
      <!-- 固定資料 -->
      <el-form
        :model="basicData"
        label-position="top"
        class="basicDataForm"
      >
        <el-form-item
          v-if="isAuthorizationAccount"
          label="手機"
        >
          <div>{{ basicData.Phone }}</div>
        </el-form-item>
        <el-form-item
          v-if="isAuthorizationAccount"
          label="姓名"
        >
          <div>{{ basicData.Name }}</div>
        </el-form-item>
        <el-form-item label="打卡時間">
          <div v-if="basicData.ClockTime">
            {{ basicData.ClockTime.slice(0, -3) }}
          </div>
          <span class="tip">(實際打卡時間以申請送出時間為準)</span>
        </el-form-item>
      </el-form>
      <!-- / 固定資料 -->
      <!-- 填寫區塊 -->
      <el-form
        ref="disposableClockInForm"
        :model="formData"
        :rules="formDataRules"
        label-position="top"
        class="form"
      >
        <el-form-item
          v-if="!isAuthorizationAccount"
          key="formDataphone"
          label="手機"
          prop="phone"
          class="left required phone"
        >
          <el-input
            ref="phone"
            v-model="formData.phone"
            placeholder="請輸入手機號碼"
            maxlength="10"
          />
        </el-form-item>
        <el-form-item
          v-if="!isAuthorizationAccount"
          key="formDataname"
          label="姓名"
          prop="name"
          class="right required"
        >
          <el-input
            v-model="formData.name"
            placeholder="請輸入姓名"
            maxlength="6"
          />
        </el-form-item>
        <el-form-item
          label="班別"
          prop="managerShifts"
          class="left"
        >
          <el-select
            v-model="formData.managerShifts"
            placeholder="請選擇班別"
          >
            <el-option
              v-for="item in managerShiftsOptions"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="職務"
          prop="managerJob"
          class="right"
        >
          <el-select
            v-model="formData.managerJob"
            placeholder="請選擇職務"
          >
            <el-option
              v-for="item in managerJobOptions"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="備註"
          class="note"
        >
          <el-input
            v-model="formData.note"
            type="textarea"
            :rows="3"
            placeholder="請填寫申請原因"
            maxlength="50"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <!-- / 填寫區塊 -->
      <div class="tip">
        ※為避免影響薪資核算，請確實輸入資料
      </div>
      <el-button
        type="primary"
        round
        @click="submit()"
      >
        送出
      </el-button>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data () {
    const formDataRule = (rule, value, callback) => {
      if (this.isAuthorizationAccount) { return callback() }
      // eslint-disable-next-line eqeqeq
      if (rule.field == 'name') { // 姓名欄位驗證
        // eslint-disable-next-line eqeqeq
        if (value == '' || value == undefined) { return callback(new Error('姓名不可為空')) } else if (/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g.test(value)) { return callback(new Error('姓名格式錯誤，不可填入特殊字元')) } else { return callback() }
      } else { // 手機號碼欄位驗證
        // eslint-disable-next-line eqeqeq
        if (value == '' || value == undefined) { return callback(new Error('手機不可為空')) } else if (!(/^09[0-9]{8}$/.test(value))) { return callback(new Error('手機格式錯誤，請輸入正確手機號碼')) } else { return callback() }
      }
    }
    return {
      dialogVisible: false,
      isAuthorizationAccount: true,
      requestData: null,
      basicData: {},
      formData: {
        phone: '',
        name: '',
        managerShifts: '',
        managerJob: '',
        note: ''
      },
      formDataRules: {
        name: [
          { min: 2, max: 6, message: '字數限制為2至6位', trigger: 'blur' },
          { validator: formDataRule, trigger: ['blur', 'change'] }
        ],
        phone: [
          { validator: formDataRule, trigger: 'blur' }
        ],
        managerShifts: [
          { required: true, message: '班別不可為空', trigger: ['blur', 'change'] }
        ],
        managerJob: [
          { required: true, message: '職務不可為空', trigger: ['blur', 'change'] }
        ]
      },
      managerShiftsOptions: [], // 班別選項
      managerJobOptions: [] // 職務選項
    }
  },
  mounted () {
    this.getOptionList()
  },
  methods: {
    openDialog (requestData, data) {
      console.log(requestData)
      this.dialogVisible = true
      this.requestData = requestData
      if (data) { // 為實名制帳號（社區管理人員帳號）打卡，有實名制資料
        this.isAuthorizationAccount = true
        this.basicData = data
      } else {
        this.isAuthorizationAccount = false
        this.basicData.ClockTime = this.$newFormatDate(new Date())
        this.$nextTick(() => {
          this.$refs.phone.focus()
        })
      }
      this.$nextTick(() => {
        this.$refs.disposableClockInForm.resetFields()
      })
    },
    // 取得職務班別選項
    getOptionList () {
      apiAttendanceManagement.ClockIn.GetCompanyJobTitleAndShiftClass(
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.managerShiftsOptions = res.data.Data.ShiftClasses
          this.managerJobOptions = res.data.Data.JobTitles
        }
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 送出
    submit () {
      console.log('submit')
      this.$refs.disposableClockInForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.requestData.set('JobTitleId', this.formData.managerJob)
          this.requestData.set('ShiftClassId', this.formData.managerShifts)
          this.requestData.set('Note', this.formData.note)
          if (this.isAuthorizationAccount) { this.postNotInCompanyClockIn() } else { this.postOneTimeClockIn() }
        } else {
          return false
        }
      })
    },
    // 有實名制打卡API
    postNotInCompanyClockIn () {
      apiAttendanceManagement.ClockIn.PostNotInCompanyClockIn(
        this.requestData
      ).then(res => {
        // 打卡成功
        if (res.data.Status === 1) {
          this.$alert('申請已交由主管審核，同意後打卡紀錄有效', '申請送出', {
            confirmButtonText: '確定',
            type: 'warning',
            callback: action => {
              this.$toMainPage()
            }
          })
        }
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 一次性打卡
    postOneTimeClockIn () {
      this.requestData.set('Phone', this.formData.phone)
      this.requestData.set('Name', this.formData.name)
      apiAttendanceManagement.ClockIn.PostOneTimeClockIn(
        this.requestData
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.data.Status == 1) {
          if (res.data.Data.HasAuthorization) {
            this.$alert('申請已交由主管審核，同意後打卡紀錄有效', '申請送出', {
              confirmButtonText: '確定',
              type: 'warning',
              callback: action => {
                this.$toMainPage()
              }
            })
          } else {
            this.$confirm('您還未註冊社區管理人員帳號，註冊完成後，將不用每次輸入資料。', '申請送出', {
              confirmButtonText: '註冊',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              localStorage.setItem('loginStatus', false)
              this.$router.push({ name: 'LoginMain', params: { page: 'rigister' } })
            }).catch(() => {
              this.$toMainPage()
            })
          }
        }
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
      })
    },
    init () {
      this.formData = {
        phone: '',
        name: '',
        managerShifts: '',
        managerJob: '',
        note: ''
      }
      this.requestData = null
    }
  }
}
</script>
<style lang="sass" scoped>
#DisposableClockIn_main
  ::v-deep .el-dialog
    +basicDialog
    .el-dialog__body
      padding: 24px 16px 32px
  ::v-deep .el-form.basicDataForm
    box-sizing: border-box
    border-bottom: 3px solid $borderDark1
    padding: 0 8px
    display: flex
    .el-form-item
      flex: 1
      text-align: left
      margin-bottom: 8px
      .el-form-item__label
        font-size: 17px
      .el-form-item__content
        font-size: 23px
        font-weight: 600
        color: #464646
        letter-spacing: 1px
      .tip
        font-weight: normal
        font-size: 13px
        color: $dangerColor
        margin: 0
        letter-spacing: 0
  ::v-deep .el-form.form
    box-sizing: border-box
    border-bottom: 1px solid #999
    padding: 40px 8px 18px
    width: 100%
    .el-form-item
      width: 50%
      text-align: left
      padding-right: 0
      position: relative
      margin-bottom: 24px
      &.left
        padding-right: 12px
      &.right
        padding-left: 12px
      &.note
        width: 100%
      .el-form-item__label
        line-height: 24px
        font-size: 17px
      &.is-required,&.required
        .el-form-item__label
          position: relative
          +redStar
      .el-select
        width: 100%
  .tip
    margin: 11px 8px 32px
    color: $dangerColor
    text-align: left
    font-size: 16px
</style>
